import * as api from '@/api'
import { pbError } from '@/pb'
import { normalizePhone, sleep, useInputState } from '@/utils'
import styled from '@emotion/styled'
import { Button, Paper, TextField } from '@mui/material'
import { useState } from 'react'
import VersionInfo from './VersionInfo'


const LoginFormRoot = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background: #121212;
`

const LoginFormContainer = styled(Paper)`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  & > *:not(:last-child) {
    margin-bottom: 1rem;
  }
  max-width: 300px;
`

const checkerTimeoutMs = 3000
const checkerTimeoutMaxDuration = 1000 * 60

export const LoginForm = () => {
  const [user, setUser] = useInputState('')
  const [pass, setPass] = useInputState('')

  const [callHere, setCallHere] = useState('')
  const callHereNormalized = normalizePhone(callHere)

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const isEmail = user.includes('@')
  const phoneNumber = normalizePhone(user)
  const userValid = isEmail || !!phoneNumber

  const loginByPhone = async () => {
    const resp = await api.requestAuthByOutgoingCall({ phoneNumber })
    const { requestID, outgoingID } = resp
    setCallHere(outgoingID)

    const checkerTimeoutTimeStarted = Date.now()
    let loggedIn = false
    while (Date.now() - checkerTimeoutTimeStarted <= checkerTimeoutMaxDuration) {
      loggedIn = await api.requestAuthByOutgoingCall({ phoneNumber, requestID })
        .then(auth => {
          if (auth.token && auth.record) {
            pb.authStore.save(auth.token, auth.record)
            return true
          } else {
            throw new Error('Auth response malformed')
          }
        })
        .catch(err => {
          if (err.message.includes("Failed to fetch")) {
            // ignore failed to fetch errors
            return false
          }
          if (err.message.includes("1c 4034")) {
            // ignore waiting for callback
            return false
          }
          throw err
        })
      if (loggedIn) break
      await sleep(checkerTimeoutMs)
    }
    if (!loggedIn) throw new Error('Login timeout')
  }

  const loginByEmail = async () => await pb.collection('users').authWithPassword(user, pass)

  const handleLoginClick = () => {
    const login = !!phoneNumber ? loginByPhone : loginByEmail
    setCallHere('')
    setError('')
    setLoading(true)
    login().then(() => {
      setCallHere('')
      setLoading(false)
    }).catch(e => {
      setCallHere('')
      setLoading(false)
      setError(pbError(e))
    })
  }

  return <LoginFormRoot>
    <LoginFormContainer>
      <img src="/logo.webp" />
      <TextField label="Номер телефона / Логин" variant="standard" value={user} onChange={setUser} disabled={loading} />
      <TextField label="Пароль" variant="standard" type="password" value={pass} onChange={setPass} disabled={loading} style={{ display: isEmail ? undefined : 'none' }} />
      {!!callHere && 
        <div style={{ textAlign: 'center' }}>
          Позвоните по номеру
          <br /><a style={{color:'inherit', fontWeight: 'bold'}} href={'tel:' + callHereNormalized}>{callHere}</a>
          <br />для подтверждения входа
        </div>
      }
      <Button variant="contained" loading={loading} disabled={!userValid} onClick={handleLoginClick}>Войти</Button>
      {!!error && <code>{error}</code>}
      <VersionInfo />
    </LoginFormContainer>
  </LoginFormRoot>
}